import React from "react";
import { FormattedMessage } from "react-intl";

import * as Yup from "yup";

export const CrimesFormSchema = Yup.object().shape({
  crime: Yup.object().required(
    <FormattedMessage id="validation_enter_crime" />
  ),
  crime_case_number: Yup.string().required(
    <FormattedMessage id="validation_enter_crime_case_number" />
  ),
  crime_verdict_date: Yup.string().required(
    <FormattedMessage id="validation_enter_crime_date" />
  ),
  court: Yup.object().required(
    <FormattedMessage id="validation_enter_court" />
  ),
  crime_sentence: Yup.string().required(
    <FormattedMessage id="validation_enter_crime_sentence" />
  ),
});
